module.exports = __webpack_public_path__ + "img/delivery-light.f20810e0.svg";